import React from "react";
import "./Input.css";
import { X } from "lucide-react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    onClear?: () => void;
    containerClassName?: string;
    startIcon?: React.ReactNode;
}

export function Input({
    onClear,
    className,
    containerClassName,
    startIcon,
    ...props
}: InputProps) {
    return (
        <div className={`atom-input-wrapper ${containerClassName || ""}`}>
            {startIcon && (
                <div className="atom-input-start-icon">{startIcon}</div>
            )}
            <input className={`atom-input ${className || ""}`} {...props} />
            {props.value && onClear && (
                <button
                    className="atom-input-clear"
                    onClick={onClear}
                    type="button"
                    aria-label="Clear input"
                >
                    <X size={16} />
                </button>
            )}
        </div>
    );
}

export default Input;
